import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'gc-comment-author',
  templateUrl: './comment-author.component.html',
  styleUrl: './comment-author.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class CommentAuthorComponent {
  name = input.required<string>();
  date = input.required<string>();
}
